import { TokenStorage } from '@/Domain/Account/TokenStorage'

export class SessionTokenStorage implements TokenStorage {
  storeToken (token: string): void {
    sessionStorage.setItem('sobre-e-token', token)
  }

  getToken (): string {
    const token = sessionStorage.getItem('sobre-e-token')
    return token === null ? '' : token
  }
}
